import {
  Gamepad2,
  Briefcase,
  Tv,
  Wifi,
  ShieldCheck,
  Users,
} from "lucide-react";

const items = [
  {
    icon: Gamepad2,
    title: "Gaming & Streaming",
    desc: "Nueva vertical: para quienes juegan, compiten, transmiten y crean.",
    color: "text-pink-500",
    bg: "bg-pink-50",
    href: "/gaming",
    tag: "Vertical",
  },
  {
    icon: Briefcase,
    title: "Teletrabajo",
    desc: "Videollamadas fluidas y VPN estable.",
    color: "text-sky-500",
    bg: "bg-sky-50",
  },
  {
    icon: Tv,
    title: "Streaming 4K",
    desc: "Netflix, Disney+ y más sin buffering.",
    color: "text-rose-500",
    bg: "bg-rose-50",
  },
  {
    icon: Wifi,
    title: "WiFi moderno",
    desc: "Routers dual-band y WiFi 6 incluidos.",
    color: "text-indigo-500",
    bg: "bg-indigo-50",
  },
  {
    icon: ShieldCheck,
    title: "Estable 24/7",
    desc: "Fibra directa. Sin interferencias.",
    color: "text-emerald-500",
    bg: "bg-emerald-50",
  },
  {
    icon: Users,
    title: "Atención humana",
    desc: "Soporte local que responde de verdad.",
    color: "text-fuchsia-500",
    bg: "bg-fuchsia-50",
  },
];

const Features = () => (
  <section className="relative bg-white py-14">
    <div className="mx-auto max-w-7xl px-6">
      <div className="mb-10 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-pink-500">
          Fibra óptica para todo
        </p>
        <h2 className="mt-2 text-3xl font-black text-slate-900 md:text-4xl">
          Conectividad sin límites
        </h2>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map(({ icon: Icon, title, desc, color, bg, href, tag }) => {
          const Wrapper = href ? "a" : "div";
          const wrapperProps = href
            ? { href, "data-testid": `feature-${title.toLowerCase().split(" ")[0]}` }
            : {};
          return (
            <Wrapper
              key={title}
              {...wrapperProps}
              className="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:border-pink-200 hover:shadow-lg hover:shadow-pink-100/50"
            >
              <div
                className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl ${bg} ${color}`}
              >
                <Icon className="h-6 w-6" />
              </div>
              <h3 className="mt-4 text-xl font-bold text-slate-900">{title}</h3>
              <p className="mt-2 text-sm text-slate-600">{desc}</p>
              {tag && (
                <span className="absolute right-4 top-4 rounded-full bg-pink-50 px-2 py-0.5 text-[9px] font-black uppercase tracking-widest text-pink-600">
                  {tag}
                </span>
              )}
            </Wrapper>
          );
        })}
      </div>
    </div>
  </section>
);

export default Features;
